export default __webpack_public_path__ + "static/media/vip-banner-m-cn.cac7a17f.webp";